import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../../common/global-constants";
import { BOOdontologyRadiologicExamType } from "../../models/odo/BOOdontologyRadiologicExamType.model";

@Injectable({
  providedIn: 'root'
})

export class OdontologyRadiologicExamTypeService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/OdontologyRadiologicExamType';

    constructor(private http:HttpClient){}

    getAll():Observable<BOOdontologyRadiologicExamType[]>{
        return this.http.get<BOOdontologyRadiologicExamType[]>(this.myAppUrl + this.myApiUrl);
    }


  }
